import React from 'react'
import Button from './Button'

const Eateries = ({ eateries }) => {

  return (
    <div className='card-group'>
      {eateries.map((eateries) => ( 
        <div className="card" key={eateries.id}>
            <div>
              <img src={eateries.image_url} alt=""/>
            </div>

            <div>
              <h3> {eateries.name} </h3>
              <p>Rating:  {eateries.rating}/5 Stars</p>
              <p>Price:  {eateries.price}</p>
              <p>Reviews: {eateries.review_count}</p>
              <Button eateries={eateries}/>
            </div>
        </div>
      ))}    
    </div>   
  )
}

export default Eateries